/**
 * @generated SignedSource<<57b15a9ca3ead1bb172ee597fd4d8960>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type KPIEditSectionsSectionHeader_Team$data = {
  readonly color: string | null;
  readonly icon: TeamIcon | null;
  readonly name: string;
  readonly " $fragmentType": "KPIEditSectionsSectionHeader_Team";
};
export type KPIEditSectionsSectionHeader_Team$key = {
  readonly " $data"?: KPIEditSectionsSectionHeader_Team$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIEditSectionsSectionHeader_Team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIEditSectionsSectionHeader_Team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "fe2e67eae4fbe437c12c752ddf4be667";

export default node;
